import React from 'react'
import mp3 from '../../../assets/images/icons/files/MP3.svg'
import mp4 from '../../../assets/images/icons/files/MP4.svg'
import { OrderPreview } from '../../../types/task'
import { fixImgSrc } from '../../../utils/tools'

interface Cprops {
  thumb: OrderPreview
}

const ImageThumb: React.FC<Cprops> = ({ thumb }) => {
  return <img className="image" src={fixImgSrc(thumb.image.url)} alt="preview" />
}

const VideoThumb = () => {
  return <img className="icon" src={mp4} alt="icon" />
}

const AudioThumb = () => {
  return <img className="icon" src={mp3} alt="icon" />
}

const Thumb: React.FC<Cprops> = ({ thumb }) => {
  let fileType = ''

  // Try to get file type from name first
  if (thumb.name && thumb.name.includes('.')) {
    const [fileExtension] = thumb.name.split('.').reverse()
    fileType = fileExtension
  } else if (thumb.image && thumb.image.url) {
    // If no extension in name, try to extract from URL
    const urlParts = thumb.image.url.split('.')
    if (urlParts.length > 1) {
      const [lastPart] = urlParts.slice(-1)
      fileType = lastPart || ''
      // Remove any query parameters
      const [fileType1] = fileType.split('?')
      fileType = fileType1
    }
  }

  fileType = fileType.toLocaleLowerCase()

  if (fileType === 'mp4') {
    return <VideoThumb />
  }

  if (fileType === 'mp3') {
    return <AudioThumb />
  }

  if (['svg', 'jpg', 'jpeg', 'png'].includes(fileType)) {
    return <ImageThumb thumb={thumb} />
  }

  // Default to image if we still can't determine the type but we have an URL
  if (thumb.image && thumb.image.url) {
    return <ImageThumb thumb={thumb} />
  }

  return null
}

export default Thumb
